/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from "react-intl";
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const intl = useIntl();
  const {currentUser} = useAuth();
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          {(currentUser?.photo)?(
            <div className='symbol symbol-50px me-5'>
              <img alt='Logo' src={toAbsoluteUrl(`${currentUser.photo}`)} />
            </div>
          ):(
            <div className='symbol symbol-50px me-5'>
              <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
            </div>
          )}

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.firstname} {currentUser?.lastname}
            </div>
            <a href={'mailto:' + currentUser?.email } className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
            {/* <span className='text-success fw-bolder fs-8 py-1'>Tipster premium</span> */}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/user/account/overview/' + currentUser?.id} className='menu-link px-5'>
          {intl.formatMessage({ id: "HEADER.USER.MENU.PROFILE" })}
        </Link>
      </div>

      <Languages />

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5 my-1'>
        <Link to={'/user/account/settings/' + currentUser?.id } className='menu-link px-5'>
        {intl.formatMessage({ id: "HEADER.USER.MENU.SETTINGS" })}
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <Link to='/logout' className='menu-link px-5'>
        {intl.formatMessage({ id: "HEADER.USER.MENU.SIGN_OUT" })}
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
